import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import {jwtDecode} from 'jwt-decode';
import { REACT_APP_LOGIN_PAGE } from '../../KeyVariables';

// Auth context interface
interface AuthContextProps {
  user: any;
  token: string | null;
  isAuth: boolean;
  loading: boolean;
  error: string | null;
}

// Create the Auth context
const AuthAvangarContext = createContext<AuthContextProps | undefined>(undefined);

export const useAuthContext = () => {
  const context = useContext(AuthAvangarContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthAvangardProvider = ({ children }: AuthProviderProps) => {
  const [token, setToken] = useState<string | null>(null);
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const location = window.location;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get('t');
    const localToken = localStorage.getItem('accessToken');

    const validateToken = (token: string) => {
      try {
        const decodedToken: any = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp > currentTime) {
          setToken(token);
          setIsAuth(true);
          localStorage.setItem('accessToken', token);

        queryParams.delete('t');
          const newUrl = `${location.origin}${location.pathname}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
          window.history.replaceState({}, '', newUrl);
        } else {
          throw new Error('Token expired');
        }
      } catch (err) {
        setError('Invalid or expired token');
        setIsAuth(false);
        window.location.href = REACT_APP_LOGIN_PAGE + `?redirectUrl=${window.location.href}`; 
      } finally {
        setLoading(false);
      }
    };

    const tokenToValidate = queryToken || localToken;
    if (tokenToValidate) {
      validateToken(tokenToValidate);
    } else {
      setLoading(false);
        window.location.href = REACT_APP_LOGIN_PAGE+ `?redirectUrl=${window.location.href}`; 
    }
  }, [location]);

  return (
    <AuthAvangarContext.Provider value={{ user: null, token, isAuth, loading, error }}>
      {children}
    </AuthAvangarContext.Provider>
  );
};